import List from '@utils/list'

const { Table, Search, Jurisdiction } = List

const jurisdiction = new Jurisdiction('materiel.category')
  .lib('add').to('Materiel.Category.Add')
  .lib('modify').modify('Materiel.Category.Modify')
  .lib('delete')
  .lib('export')
  .lib('import')

const search = new Search('materiel.category')
  .add('orgNo')
  .add('groupNoIndistinct')
  .add('groupNameIndistinct')
  .add('statusCode')
  .add('remarkIndistinct')

const table = new Table('materiel.category')
  .add('groupNo')
  .add('groupName')
  .add('orgNo')
  .add('statusCode')
  .add('remark')
  .add('createName')
  .add('createDate')
  .add('updateName')
  .add('updateDate')

export default new List()
  .jurisdiction(jurisdiction)
  .search(search)
  .table(table)
  .end()
